import script from "./WebAIAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./WebAIAgent.vue?vue&type=script&setup=true&lang=js"

import "./WebAIAgent.vue?vue&type=style&index=0&id=2554242d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2554242d"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpinnerBars from 'quasar/src/components/spinner/QSpinnerBars.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QBtn,QInput,QSpinnerBars});
